/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TextInputDefault } from './text-input-default.story';
export { default as TextInputRequired } from './text-input-required.story';
export { default as TextInputOptional } from './text-input-optional.story';
export { default as TextInputDisabled } from './text-input-disabled.story';
export { default as TextInputReadonly } from './text-input-readonly.story';
export { default as TextInputError } from './text-input-error.story';
export { default as TextInputInformationIcon } from './text-input-information-icon.story';
export { default as TextInputEmail } from './text-input-email.story';
export { default as TextInputNumber } from './text-input-number.story';
export { default as TextInputWithIcons } from './text-input-with-icons.story';
export { default as TextInputPassword } from './text-input-password.story';
export { default as TextInputSizes } from './text-input-sizes.story';
export { default as TextInputLoading } from './text-input-loading.story';
export { default as TextInputFull } from './text-input-full.story';
export { default as TextInputClearable } from './text-input-clearable.story';
export { default as TextInputLoadingSpinner } from './text-input-loading-spinner.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import TextInputClearableSourceRaw from './text-input-clearable.story?raw';
import TextInputDefaultSourceRaw from './text-input-default.story?raw';
import TextInputDisabledSourceRaw from './text-input-disabled.story?raw';
import TextInputEmailSourceRaw from './text-input-email.story?raw';
import TextInputErrorSourceRaw from './text-input-error.story?raw';
import TextInputFullSourceRaw from './text-input-full.story?raw';
import TextInputInformationIconSourceRaw from './text-input-information-icon.story?raw';
import TextInputLoadingSourceRaw from './text-input-loading.story?raw';
import TextInputLoadingSpinnerSourceRaw from './text-input-loading-spinner.story?raw';
import TextInputNumberSourceRaw from './text-input-number.story?raw';
import TextInputOptionalSourceRaw from './text-input-optional.story?raw';
import TextInputPasswordSourceRaw from './text-input-password.story?raw';
import TextInputReadonlySourceRaw from './text-input-readonly.story?raw';
import TextInputRequiredSourceRaw from './text-input-required.story?raw';
import TextInputSizesSourceRaw from './text-input-sizes.story?raw';
import TextInputWithIconsSourceRaw from './text-input-with-icons.story?raw';

export const TextInputDefaultSource = removeLicenseHeader(
  TextInputDefaultSourceRaw,
);
export const TextInputRequiredSource = removeLicenseHeader(
  TextInputRequiredSourceRaw,
);
export const TextInputOptionalSource = removeLicenseHeader(
  TextInputOptionalSourceRaw,
);
export const TextInputDisabledSource = removeLicenseHeader(
  TextInputDisabledSourceRaw,
);
export const TextInputReadonlySource = removeLicenseHeader(
  TextInputReadonlySourceRaw,
);
export const TextInputErrorSource = removeLicenseHeader(
  TextInputErrorSourceRaw,
);
export const TextInputInformationIconSource = removeLicenseHeader(
  TextInputInformationIconSourceRaw,
);
export const TextInputEmailSource = removeLicenseHeader(
  TextInputEmailSourceRaw,
);
export const TextInputNumberSource = removeLicenseHeader(
  TextInputNumberSourceRaw,
);
export const TextInputWithIconsSource = removeLicenseHeader(
  TextInputWithIconsSourceRaw,
);
export const TextInputPasswordSource = removeLicenseHeader(
  TextInputPasswordSourceRaw,
);
export const TextInputSizesSource = removeLicenseHeader(
  TextInputSizesSourceRaw,
);
export const TextInputLoadingSource = removeLicenseHeader(
  TextInputLoadingSourceRaw,
);
export const TextInputFullSource = removeLicenseHeader(TextInputFullSourceRaw);
export const TextInputClearableSource = removeLicenseHeader(
  TextInputClearableSourceRaw,
);
export const TextInputLoadingSpinnerSource = removeLicenseHeader(
  TextInputLoadingSpinnerSourceRaw,
);
